import { HttpCancelledError, xhrHttpClient, type HttpClient } from "@inertiajs/core";
import axios from "axios";

import { withMaintenanceRetry } from "./maintenance-retry";

/** Inertia 3 uses its own XHR transport, separate from the API's axios instance. */
export const maintenanceHttpClient: HttpClient = {
  async request(config) {
    try {
      return await withMaintenanceRetry((signal) => xhrHttpClient.request({ ...config, signal }), config);
    } catch (error) {
      if (axios.isCancel(error)) {
        throw new HttpCancelledError();
      }
      throw error;
    }
  },
};
